export default "__VITE_ASSET__BIFWA9ZQ__"